// Helpers compartidos para reportes en Excel armados en el navegador con ExcelJS
// (ReporteRecurrenteModal - ficha 190, ReporteMovimientosModal - ficha 186).
import moment from 'moment';

export const FORMATO_MONEDA = '#,##0.00';
export const FORMATO_FECHA = 'DD/MM/YYYY';

export const fechaDMY = (valor) => (valor ? moment(valor).format(FORMATO_FECHA) : '');

/** Da formato de encabezado de tabla a todas las celdas de un renglón. */
export const aplicarEncabezado = (row) => {
  /* eslint-disable no-param-reassign -- ExcelJS se formatea mutando la celda */
  row.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF234E5F' } };
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  });
  /* eslint-enable no-param-reassign */
};

/** Escribe líneas de texto informativo (título, filtros) y un renglón en blanco. */
export const escribirLineasEncabezado = (ws, lineas) => {
  lineas.forEach((texto, idx) => {
    const row = ws.addRow([texto]);
    if (idx < 2) row.font = { bold: true, size: idx === 0 ? 14 : 12 };
  });
  ws.addRow([]);
};

/**
 * Escribe una tabla (encabezado + filas) en la hoja.
 * @param {object} ws hoja de ExcelJS
 * @param {{ header: string, key: string, width?: number, numFmt?: string,
 *   fecha?: boolean }[]} columnas
 * @param {object[]} filas
 */
export const escribirTabla = (ws, columnas, filas) => {
  aplicarEncabezado(ws.addRow(columnas.map((c) => c.header)));
  filas.forEach((f) => {
    const row = ws.addRow(columnas.map((c) => {
      const valor = f[c.key];
      if (c.fecha) return fechaDMY(valor);
      if (c.numFmt) return valor === null || valor === undefined ? null : Number(valor);
      return valor ?? '';
    }));
    columnas.forEach((c, idx) => {
      if (c.numFmt) row.getCell(idx + 1).numFmt = c.numFmt;
    });
  });
  columnas.forEach((c, idx) => {
    const columna = ws.getColumn(idx + 1);
    columna.width = c.width || 15;
  });
};

export const descargarWorkbook = async (workbook, nombreArchivo) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  URL.revokeObjectURL(url);
};
